/*
 * Keeps the cart page in sync with changes it did not make itself.
 *
 * Two gaps this closes:
 *  - Adding from the recommendations carousel goes through product-form, which
 *    refreshes the cart drawer (or navigates away) but leaves the cart page's own
 *    markup stale.
 *  - #cart-gift-progress and #cart-recommendations sit outside .js-contents, the
 *    only thing cart.js re-renders, so a quantity change or removal would leave
 *    the gift bar and the carousel stale.
 */
if (!window.cartPageRefreshBound) {
  window.cartPageRefreshBound = true;

  document.addEventListener('DOMContentLoaded', () => {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    // data-id lives on #main-cart-items, not on <cart-items> itself.
    const sectionId = document.getElementById('main-cart-items')?.dataset.id;
    if (!sectionId) return;

    const parse = (html, selector) =>
      new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // cart.js has already repainted .js-contents for its own updates; only the
      // carousel is left over. Anything else needs the whole page refreshed.
      const ownUpdate = event.source === 'cart-items';
      const sections = ownUpdate ? [] : cartItems.getSectionsToRender();
      const sectionNames = [...new Set([...sections.map((section) => section.section), sectionId])];
      const url = `${window.location.pathname}?sections=${sectionNames.join(',')}`;

      return fetch(url)
        .then((response) => response.json())
        .then((data) => {
          sections.forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container || !data[section.section]) return;
            const target = container.querySelector(section.selector) || container;
            target.innerHTML = cartItems.getSectionInnerHTML(data[section.section], section.selector);
          });

          ['cart-gift-progress', 'cart-recommendations'].forEach((id) => {
            const container = document.getElementById(id);
            const updated = data[sectionId] && parse(data[sectionId], `#${id}`);
            if (container && updated) container.innerHTML = updated.innerHTML;
          });

          if (!ownUpdate) {
            const cartFooter = document.getElementById('main-cart-footer');
            cartItems.classList.remove('is-empty');
            if (cartFooter) cartFooter.classList.remove('is-empty');
          }
        })
        .catch((e) => console.error(e));
    });
  });
}
